import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=44595c2d&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"
import style0 from "./Companies.vue?vue&type=style&index=0&id=44595c2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44595c2d",
  null
  
)

export default component.exports